import * as z from "zod/v4";

export const rejectMergeSuggestion = {
  name: "rejectMergeSuggestion" as const,
  input: z.object({ groupIds: z.array(z.string()) }),
  output: z.object({ success: z.boolean() }),
};
